import Vue, { provide } from 'vue';
import VueRouter from 'vue-router';

// Vuetify icons mdi
import '@mdi/font/css/materialdesignicons.css';

// Automatic scroll loading
import VueObserveVisibility from 'vue-observe-visibility';

// Vuetify Dependecies
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import VueCodemirror from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import VueApollo from 'vue-apollo';

// Apollo Dependencies
import { ApolloClients, provideApolloClient } from '@vue/apollo-composable';
import VueFroala from 'vue-froala-wysiwyg';
import createApolloClient from './apollo.config';

import App from './App.vue';
import store from './store';
import router from './router';

// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';

// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

// ENVIROMENT VARIABLES
let environmentVariables = require('../config.env.json');

const isProd = process.env.NODE_ENV === 'production';

if (!isProd) {
  try {
    environmentVariables = { ...environmentVariables, ...require('../config.local.env.json') };
  } catch (ex) {
  }
}

// Options
const opts = {
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#208ee6',
        secondary: '#424242',
        darkfield: '#292929',
        blue: '#208ee6'
      },
      dark: {
        primary: '#343434',
        secondary: '#424242',
        darkfield: '#292929',
        blue: '#208ee6',
        white: '#ffffff',
        black: '#000000',
        grey: '#a8a8a8'
      }
    }
  },
  icons: { iconfont: 'mdi' }
};

Vue.use(VueFroala);

// Imports
Vue.use(Vuetify);
Vue.use(VueObserveVisibility);
Vue.use(VueCodemirror);
Vue.use(VueRouter);

Vue.use(VueApollo);

Vue.config.productionTip = false;

// Recursive Generate Form import
Vue.component('GenerateForm', require('./components/editor/GenerateForm.vue').default);

// Set default project enviroment

let environment = null;

if (process.env.VUE_APP_DEV_PROJECT) {
  environment = environmentVariables[process.env.VUE_APP_DEV_PROJECT];
}

// Find out if has a specific project associated
Object.keys(environmentVariables).map(key => {
  const domain = environmentVariables[key].PROJECT_DOMAIN;
  if (domain) {
    const domainRule = new RegExp(domain);
    if (domainRule.test(window.location.hostname)) {
      environment = environmentVariables[key];
    }
  }
});

const apolloClient = createApolloClient(environment[process.env.VUE_APP_ENV].VUE_APP_GRAPHQL_SERVER_HTTP, `pim-${environment.PROJECT}-dashboard`);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: { $query: { } // fetchPolicy: 'cache-and-network',
  },
  errorHandler (error) {
    // eslint-disable-next-line no-console
    console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
  }
});

new Vue({
  setup () {
    provide(ApolloClients, { default: apolloClient });
    provideApolloClient(apolloClient);
  },
  apolloProvider: apolloProvider,
  router,
  store,
  vuetify: new Vuetify(opts),
  render: h => h(App),
  beforeCreate () {
    // If its not a keep alive route
    if (!this.$route.meta.keepAlive) {
      store.commit('setInclude', [this.$route.meta.componentName]);
    }

    store.commit('setEnvironment', environment);
  }
}).$mount('#app');

// const { defaultClient } = apolloProvider;
// export { defaultClient };
